import axios from "axios";
import { getField, updateField } from "vuex-map-fields";
import { axiosCall } from "../../utils/axiosCall";
import store from "../index";

function initialState() {
  return {
    token: `${localStorage.getItem("user-token")}` || "",
    /*    expirationDate: '',*/
    userAccount: {},
    userAccountRoles: [],
    businesses: [],
    currentAccountRoleId: null,
    status: {
      login: "",
      userAccount: "",
      businesses: "",
    },
    tokenExpired: false,
    tokenExpirationDate: null,
    permissions: [],
  };
}

const state = initialState;

const getters = {
  isAuthenticated: (state) => !!state.token,
  /*getExpirationDate: state => state.expirationDate,*/
  getCurrentAccountRoleId: (state) => state.currentAccountRoleId,
  /* getExpirationDate: state => state.expirationDate,*/
  getTokenExpirationDate: (state) => state.tokenExpirationDate,
  getTokenExpired: (state) => state.tokenExpired,
  authStatus: (state) => state.status,
  getToken: (state) => {
    return state.token.replace("Bearer ", "");
  },
  getUserAccount: (state) => state.userAccount,
  getUserAccountRoles: (state) => state.userAccountRoles,
  isPNUDADMIN: (state) => {
    const pund = state.userAccountRoles.filter(
      (role) => role.accountRoleTemplate.accessLevel === "PNUD Admin"
    );
    return pund.length > 0;
  },
  isIndicaUser: (state) => {
    const pund = state.userAccountRoles.filter(
      (role) => role.accountRoleTemplate.accessLevel === "Admin"
    );
    return pund.length > 0;
  },
  getUserAccountBusinesses: (state) => state.businesses,
  getUserAccountField: (state) => {
    return getField(state.userAccount);
  },
  getUserPermissions: (state) =>
    state.permissions.map((permission) => permission.permission.name),
};

const actions = {
  AUTH_REQUEST: async ({ dispatch }, user) => {
    // cargamos asincronicamente toda la información
    await dispatch("USERACCOUNTS_LOGIN", user); // 1. Hacemos login
    await dispatch("USERACCOUNTS_GET"); // Descargamos toda información del perfil
    /* await dispatch('USERACCOUNTS_BUSINESS') // Descargamos la información de negocios que tiene el perfil*/
    await dispatch("USERACCOUNTSROLES_GET"); // Descargamos toda información del perfil
  },
  USERACCOUNTS_LOGIN: ({ commit }, user) => {
    return new Promise((resolve, reject) => {
      commit("setUserAccountStatus", { status: "pending", key: "login" });
      axiosCall({ url: "UserAccounts/login", method: "POST", data: user })
        .then((resp) => {
          commit("setUserAccountStatus", { status: "success", key: "login" });
          commit("authSuccess", resp);
          resolve(resp);
        })
        .catch((err) => {
          commit("setUserAccountStatus", { status: "error", key: "login" });
          localStorage.removeItem("user-token");
          reject(err);
        });
    });
  },
  USERACCOUNTSROLES_GET: ({ commit, dispatch }) => {
    return new Promise((resolve, reject) => {
      axiosCall({ url: "UserAccounts/getAccountRoles" })
        .then(async (resp) => {
          commit("setUserAccountRoles", resp.data);
          if (!resp.data || !resp.data.length) {
            /* //commit('setAccountRole', resp.data[0].id)
            //await dispatch('USERACCOUNTS_BUSINESS') // Descargamos la información de negocios que tiene el perfil
          } else {*/
            //dispatch('setError', 'The user has no roles')
          } else if (resp.data.length === 1) {
            await dispatch("USER_ACCOUNT_SET_ROLE", resp.data[0].id);
            await dispatch("USERACCOUNTS_GET", resp.data[0].id);
            await dispatch("GET_PERMISSIONS", resp.data[0].id);
          }
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  USERACCOUNTS_GET: ({ commit, dispatch }) => {
    commit("setUserAccountStatus", { status: "pending", key: "userAccount" });
    return new Promise((resolve, reject) => {
      axiosCall({ url: "UserAccounts/get" })
        .then((resp) => {
          commit("setUserAccountStatus", {
            status: "success",
            key: "userAccount",
          });
          commit("setUserAccount", resp.data["account"]);
          resolve(resp);
        })
        .catch((err) => {
          commit("setUserAccountStatus", {
            status: "error",
            key: "userAccount",
          });
          dispatch("USERACCOUNTS_LOGOUT");
          reject(err);
        });
    });
  },
  GET_PERMISSIONS: async ({ commit, dispatch }, accountRoleId) => {
    let permissions = await axiosCall({
      url: `/AccessControls/getPermissions/${accountRoleId}`,
    });

    commit("setUserAccountPermissions", permissions.data.accountRoles);
  },
  USERACCOUNTS_SAVE: ({ commit }, user) => {
    commit("setUserAccountStatus", { status: "updating", key: "userAccount" });
    return new Promise((resolve, reject) => {
      axiosCall({ url: "UserAccounts/save", method: "POST", data: user })
        .then((resp) => {
          commit("setUserAccountStatus", {
            status: "success",
            key: "userAccount",
          });
          // commit('setUserAccount', resp.data['account'])
          resolve(resp);
        })
        .catch((err) => {
          commit("setUserAccountStatus", {
            status: "error",
            key: "userAccount",
          });
          reject(err);
        });
    });
  },
  USER_ACCOUNT_SET_ROLE: async ({ commit, dispatch }, accountRoleId) => {
    commit("setAccountRole", accountRoleId);
    await dispatch("USERACCOUNTS_BUSINESS"); // Descargamos la información de negocios que tiene el perfil
    await store.dispatch("BUSINESS_GET");
    await store.dispatch("SNAPSHOTS_GET");
  },
  USERACCOUNTS_BUSINESS: ({ commit }) => {
    commit("setUserAccountStatus", { status: "pending", key: "business" });
    return new Promise((resolve, reject) => {
      axiosCall({ url: "/UserAccounts/business" })
        .then(async (resp) => {
          commit("setUserAccountStatus", {
            status: "success",
            key: "business",
          });
          if (resp.data.length == 0) {
            commit("setSnapshots", null);
            commit("setUserAccountBusinesses", null);
            commit("setCurrentBusiness", null);
          } else {
            commit("setUserAccountBusinesses", resp.data["business"]); // Guardamos los negocios del usuario
            var businessToCommit =
              resp.data["business"].length > 0
                ? resp.data["business"][0]
                : null;
            const empresaDePrueba = resp.data.business.filter(
              (b) => b.name === "Empresa de Prueba S.A."
            );
            businessToCommit =
              empresaDePrueba.length > 0
                ? empresaDePrueba[0]
                : businessToCommit;
            commit("setCurrentBusiness", businessToCommit); // Definimos el negocio actual, por defecto la primera empresa             que aparece en la lista
          }
          resolve();
        })
        .catch((err) => {
          commit("setUserAccountStatus", { status: "error", key: "business" });
          reject(err);
        });
    });
  },
  USERACCOUNTS_LOGOUT: ({ commit }) => {
    // Al cerrar sesión borramos toda la información de vuex poniendo los estados en su versión inicial
    return new Promise((resolve) => {
      localStorage.removeItem("user-token");
      commit("userAccountReset");
      commit("SelfAssessmentReset");
      commit("businessReset");
      commit("indicatorReset");
      commit("invitationsReset");
      commit("pillarsReset");
      commit("opinionSurveyReset");
      resolve();
    });
  },
};

const mutations = {
  setAccountRole: (state, data) => {
    state.currentAccountRoleId = data;
  },
  setUserAccountStatus: (state, data) => {
    state.status[data.key] = data.status;
  },
  setUserAccountPermissions: (state, permissions) => {
    state.permissions = permissions;
  },
  authSuccess: (state, resp) => {
    state.token = `Bearer ${resp.data.id}`;
    localStorage.setItem("user-token", `Bearer ${resp.data.id}`);
    const infoJwt = JSON.parse(atob(resp.data.id.split(".")[1]));
    state.expirationDate = infoJwt?.exp;
    axios.defaults.headers.common["Authorization"] = `Bearer ${resp.data.id}`;
    if (resp.data.accountroleid) {
      state.currentAccountRoleId = resp.data.accountroleid;
    }
  },
  setUserAccount: (state, resp) => {
    state.userAccount = resp;
  },
  setUserAccountRoles: (state, resp) => {
    state.userAccountRoles = resp;
  },
  setUserAccountBusinesses: (state, resp) => {
    state.businesses = resp;
  },
  /*  setTokenExpiration: (state, resp) => {
    state.businesses = resp
  },*/
  setTokenExpirationDate: (state, tokenExpirationDate) => {
    state.tokenExpirationDate = tokenExpirationDate;
  },
  setTokenExpired: (state, tokenExpired) => {
    state.tokenExpired = tokenExpired;
  },
  updateUserAccountField: (state, field) => {
    updateField(state.userAccount, field);
  },
  userAccountReset: (state) => {
    const s = initialState();
    Object.keys(s).forEach((key) => {
      if (key !== "tokenExpired") {
        state[key] = s[key];
      }
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
